/**
 * The optional third-party printing partner, in one place.
 *
 * KinCode does not print, sell or deliver cards itself (§7 of the Terms of Use):
 * the print file is generated entirely in the browser and never sent anywhere. This
 * link is a plain referral to a separate commercial printer who can produce cards
 * from that file. It is a **paid affiliate link** — KinCode may earn a commission if
 * someone orders through it — which is why it is always shown with a disclosure
 * (UK ASA/CAP rules require paid referral links to be labelled as such), never as a
 * bare link. See `docs/doxzoo.md` for the fuller arrangement writeup.
 *
 * This is a display value, not a secret: it is meant to appear on the page.
 */

/** The printing partner's name, as shown in the affiliate notice. */
export const PRINT_PARTNER_NAME = "DOXZOO";

/** The affiliate referral link. Carries a `ref` code; no order or personal data is ever sent here by KinCode. */
export const PRINT_PARTNER_URL =
  "https://doxzoo.com/products/eco-friendly-business-cards?ref=qdxpbckx";
